import { useParams, Link, useNavigate } from "react-router-dom";

import { Col, Row, Button } from 'react-bootstrap';
import { useState, useEffect, useCallback } from 'react';

import ModalShell from '../common/modal-shell';
import PreviousNext from '../common/previous-next';
import BasicSpinner from '../common/basic-spinner';
// import ListView from '../common/list-view';
import PaginatedList from '../common/pagination';

import { useAuth } from "../../utils/auth-provider";
import { fetchUserImage, fetchUserImageParents } from '../../utils/fetch-helpers';

import ImageDetails from './image-details';
import ImageUpdateForm from './image-update-form';

//================================================================

export default function ImagePage(){

  const navigate = useNavigate();
  const user = useAuth();
  const params = useParams();

  const [parents, setParents] = useState(null);
  const [image, setImage] = useState(null);
  const [modalShow, setModalShow] = useState(false);

  //----------------------------------------------------------------

  const fetchImage = useCallback( async (imageId, signal) => {
    setImage(await fetchUserImage(user, imageId, signal));
  }, [user, params.imageId]);

  //----------------------------------------------------------------

  const fetchParents = useCallback(async (imageId, signal) => {
    setParents(await fetchUserImageParents(user, imageId, signal));
  }, [user, image]);

  //----------------------------------------------------------------

  useEffect(() => {
    if (!image) return;

    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchParents(image._id, signal);

    return () => abortController.abort();

  }, [image]);

  //----------------------------------------------------------------

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchImage(params.imageId, signal);

    return () => abortController.abort();

  }, [params.imageId]);

  //----------------------------------------------------------------

  return(
    <>
      {/*<PreviousNext
        objects={images}
        currentObject={image}
        onClick={setCurrentImage}
        basePath={`/dashboard/image`}
      />*/}

      { !image ?
        <BasicSpinner className="mb-4 col text-center" text={'Loading...'} />
        :
        <>
          <Row className="mb-2 align-items-center">
            <Col className="h4 text-truncate" sm={9}>
              <b>{"Image: "}</b>{image.name || ""}
            </Col>
            <Col sm={3}>
              <Button
                className="text-nowrap text-truncate w-100"
                onClick={() => setModalShow(true)}
                disabled={!image}
              >
                Edit
              </Button>
            </Col>
          </Row>

          <ImageDetails image={image}/>

          <Row className='mb-2 align-items-center'>
            <Col>
              <Button
                className="w-100"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </Col>
            <Col>
              <Button
                className="w-100"
                onClick={() => navigate(1)}
              >
                Forward
              </Button>
            </Col>
          </Row>

          { parents &&
            <>
              <hr />
              <Row className="mb-3 align-children-center">
                <Col className="h4 my-0 text-start">Parents</Col>
              </Row>

              <PaginatedList
                key="parent-collections"
                list={parents['collections']}
                name="Collections"
                type="collection"
                isPrivate
              />

              <PaginatedList
                key="parent-items"
                list={parents['items']}
                name="Items"
                type="item"
                isPrivate
              />
            </>
          }

          <ModalShell
            title="Update Image"
            show={modalShow}
            onHide={() => setModalShow(false)}
            hideFooter={true}
          >
            <ImageUpdateForm
              image={image}
              onCancel={() => setModalShow(false)}
              onUpdate={setImage}
            />
          </ModalShell>
        </>
      }
    </>
  );
}
